import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import {
  Select,
  MenuItem,
  Typography,
  ListItemIcon,
  SelectChangeEvent,
} from '@mui/material';
import React, { useState, Dispatch, SetStateAction } from 'react';

// import {
//   defaultJqlAll,
//   defaultJqlDone,
//   defaultJqlOpen,
// } from '@eng-mono/atlassian/jira/mojira-bugtracker/util-issue-list';

interface IssueListFilterProps {
  setFilter: Dispatch<SetStateAction<string>>;
}

export function IssueListFilter(props: IssueListFilterProps) {
  const [selectedValue, setSelectedValue] = useState('Open issues');

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    setSelectedValue(event.target.value);
    if (event.target.value === 'Open issues') props.setFilter('open');
    if (event.target.value === 'All issues') props.setFilter('all');
    if (event.target.value === 'Done issues') props.setFilter('done');
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '10px',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', marginRight: '16px' }}>
        {selectedValue}
      </Typography>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Select
          value={selectedValue}
          onChange={handleSelectChange}
          variant="standard"
          disableUnderline
          displayEmpty
          slotProps={{
            input: { tabIndex: 0, 'aria-label': 'issue-list-combo-box' },
          }}
          renderValue={() => 'Switch filter'}
          MenuProps={{
            PaperProps: {
              sx: {
                '& .MuiMenuItem-root': {
                  color: 'inherit',
                },
              },
            },
          }}
        >
          {['Open issues', 'All issues', 'Done issues'].map((option) => (
            <MenuItem key={option} value={option}>
              <ListItemIcon sx={{ minWidth: '32px' }}>
                {option === selectedValue ? (
                  <RadioButtonCheckedIcon fontSize="small" />
                ) : (
                  <span style={{ width: '24px' }} />
                )}
              </ListItemIcon>
              {option}
            </MenuItem>
          ))}
        </Select>
      </div>
    </div>
  );
}
